import { type ReactNode } from 'react';
import { messages } from '../i18n/messages.js';
import { useSession } from '../app/session-context.js';
import { ZonesPanel } from './ReferenceScreen.js';

/**
 * Yetkazish zonalari.
 *
 * Demoda bu punkt "Yetkazish narxlari" deb atalgan. Bizda ATAYLAB
 * "zonalari": narx maydoni tizimda umuman yo'q — u har hudud uchun
 * operator taksichi bilan gaplashib aytadi
 * (`docs/06-OCHIQ-SAVOLLAR.md`, 7-savol). "Narxlari" deb yozilsa
 * xodim bu ekrandan narx qidirardi.
 */
export function ZonesScreen(): ReactNode {
  const { locale } = useSession();
  const t = messages(locale);

  return (
    <section className="adm-page">
      <header className="adm-page__header">
        <h1 className="adm-page__title">{t.refZones}</h1>
      </header>
      <ZonesPanel hideTitle />
    </section>
  );
}
